import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { createTextMaskInputElement } from "text-mask-core";
import { AjaxService } from "src/app/service/ajax.service";
import { API, BASE_API } from "src/environments/environment";
import { UtilService } from "src/app/service/util.service";

interface Cliente {
  id?: number;
  iD_USUARIO_CLIENTE?: number;
  nome: string;
  cpf: string;
  email: string;
  telefone: string;
  endereco: string;
  tipO_DEMANDA: string;
  status: string;
  dataCadastro: Date;
  temMensagem?: boolean;
  consulado?: string;
  nomeStatus: string;
  iD_STATUS?: number;
  relatO_INICIAL?: string;
}

interface Arquivo {
  id: number;
  nome: string;
  tipo: string;
  dataUpload: Date;
  path: string;
}

interface MembroArvore {
  parentesco?: string;
  italiano?: {
    nomeCompleto: string;
    dataNascimento: string;
    localNascimento: string;
    nomeConjuge?: string;
    dataCasamento?: string;
    localCasamento?: string;
    dataObito?: string;
    localObito?: string;
  };
  filhoItaliano?: {
    nomeCompleto: string;
    dataNascimento: string;
    localNascimento: string;
    nomeConjuge?: string;
    dataCasamento?: string;
    localCasamento?: string;
    dataObito?: string;
    localObito?: string;
  };
  netoItaliano?: {
    nomeCompleto: string;
    dataNascimento: string;
    localNascimento: string;
    nomeConjuge?: string;
    dataCasamento?: string;
    localCasamento?: string;
    dataObito?: string;
    localObito?: string;
  };
  bisnetoItaliano?: {
    nomeCompleto: string;
    dataNascimento: string;
    localNascimento: string;
    nomeConjuge?: string;
    dataCasamento?: string;
    localCasamento?: string;
    dataObito?: string;
    localObito?: string;
  };
  trinetoItaliano?: {
    nomeCompleto: string;
    dataNascimento: string;
    localNascimento: string;
    nomeConjuge?: string;
    dataCasamento?: string;
    localCasamento?: string;
    dataObito?: string;
    localObito?: string;
  };
  tetranetoItaliano?: {
    nomeCompleto: string;
    dataNascimento: string;
    localNascimento: string;
    nomeConjuge?: string;
    dataCasamento?: string;
    localCasamento?: string;
    dataObito?: string;
    localObito?: string;
  };
  pentanetoItaliano?: {
    nomeCompleto: string;
    dataNascimento: string;
    localNascimento: string;
    nomeConjuge?: string;
    dataCasamento?: string;
    localCasamento?: string;
    dataObito?: string;
    localObito?: string;
  };
  hexanetoItaliano?: {
    nomeCompleto: string;
    dataNascimento: string;
    localNascimento: string;
    nomeConjuge?: string;
    dataCasamento?: string;
    localCasamento?: string;
    dataObito?: string;
    localObito?: string;
  };
  cliente?: {
    nomeCompleto: string;
    dataNascimento: string;
    localNascimento: string;
    nomeConjuge?: string;
    dataCasamento?: string;
    localCasamento?: string;
    filhos?: string;
    netos?: string;
  };
}

@Component({
  selector: "app-cadastro-cliente",
  templateUrl: "./cadastro-cliente.component.html",
  styleUrls: ["./cadastro-cliente.component.scss"],
})
export class CadastroClienteComponent implements OnInit {
  @ViewChild("formModal") formModal!: TemplateRef<any>;
  @ViewChild("arquivosModal") arquivosModal!: TemplateRef<any>;
  @ViewChild("arvoreModal") arvoreModal!: TemplateRef<any>;

  cadastroForm: FormGroup;
  modalRef!: NgbModalRef;
  clienteSelecionado: any;
  clientes: Cliente[] = [];
  clientesFiltrados: Cliente[] = [];
  loading: boolean = false;
  loadingArquivos: boolean = false;
  loadingArvore: boolean = false;
  arquivosCliente: Arquivo[] = [];
  arvoreCliente: MembroArvore | null = null;

  // Paginação
  pageIndex: number = 0;
  pageSize: number = 10;

  // Filtros
  filtroNome: string = "";
  filtroCpf: string = "";
  filtrotipO_DEMANDA: string = "";
  filtroStatus: string = "";
  filtroMensagem: string = "";

  // Lista de status
  statusList: any[] = [];

  // Áreas de concentração do PPGIT
  areasPPGIT = [
    {
      value: 'biotecnologia_biofarmaceutica',
      label: 'I. Área de concentração em Biotecnologia e Inovação Biofarmacêutica',
      description: 'Foco em desenvolvimento de produtos biotecnológicos, inovação em biofármacos e processos farmacêuticos.'
    },
    {
      value: 'gestao_inovacao_propriedade_empreendedorismo',
      label: 'II. Área de Concentração em Gestão da Inovação, Propriedade Intelectual e Empreendedorismo',
      description: 'Gestão de processos inovadores, proteção de propriedade intelectual e desenvolvimento de negócios.'
    },
    {
      value: 'novos_materiais_nanotecnologia_quimica',
      label: 'III. Área de concentração de Novos Materiais, Nanotecnologia e Química',
      description: 'Desenvolvimento de materiais avançados, aplicações nanotecnológicas e inovações químicas.'
    },
    {
      value: 'transformacao_digital_inteligencia_artificial',
      label: 'IV. Área de concentração de Transformação Digital e Inteligência Artificial',
      description: 'Tecnologias digitais, inteligência artificial, automação e inovação tecnológica.'
    },
    {
      value: 'sustentabilidade',
      label: 'V. Área de concentração de Sustentabilidade',
      description: 'Desenvolvimento sustentável, tecnologias verdes e soluções ambientais.'
    }
  ];

  // Máscaras
  cpfMask = [
    /\d/,
    /\d/,
    /\d/,
    ".",
    /\d/,
    /\d/,
    /\d/,
    ".",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
  ];
  telefoneMask = [
    "(",
    /\d/,
    /\d/,
    ")",
    " ",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ];

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private ajaxService: AjaxService,
    private util: UtilService
  ) {
    this.cadastroForm = this.fb.group({
      nome: ["", Validators.required],
      cpf: [
        "",
        [
          Validators.required,
          Validators.pattern(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/),
        ],
      ],
      email: ["", [Validators.required, Validators.email]],
      telefone: ["", Validators.required],
      endereco: ["", Validators.required],
      tipO_DEMANDA: ["", Validators.required],
      status: ["", Validators.required],
      consulado: [""],
      relatO_INICIAL: [""],
      // Novos campos do projeto
      RESUMO_PROJETO: ["", Validators.required],
      AREA_RELACAO_PPGIT: [[], Validators.required],
      OUTRA_AREA: [""],
      PALAVRAS_CHAVE: ["", Validators.required],
    });
  }

  ngOnInit(): void {
    this.carregarClientes();
    this.carregarStatus();
  }

  carregarClientes(): void {
    this.loading = true;
    this.util.showLoading();
    let url = API + "UsuarioCliente/UsuarioCliente";
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        this.util.closeLoading();
        this.clientes = response.data;
        this.clientesFiltrados = [...this.clientes];
        this.loading = false;
      },
      error: (error) => {
        this.util.closeLoading();
        console.error("Erro ao carregar clientes:", error);
        this.loading = false;
      },
    });
  }

  carregarStatus(): void {
    let url = API + "Status/Status";
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        this.statusList = response.data;
      },
      error: (error) => {
        console.error("Erro ao carregar status:", error);
      },
    });
  }

  openModal(modal: TemplateRef<any>, isNew: boolean = false): void {
    if (isNew) {
      this.clienteSelecionado = null;
      this.cadastroForm.reset({ status: "ativo" });
    }
    this.modalRef = this.modalService.open(modal, { size: "lg" });
  }

  editarCliente(cliente: Cliente): void {
    debugger;
    this.clienteSelecionado = cliente;
    this.cadastroForm.patchValue({
      nome: cliente.nome,
      cpf: cliente.cpf,
      email: cliente.email,
      telefone: cliente.telefone,
      endereco: cliente.endereco,
      tipO_DEMANDA: cliente.tipO_DEMANDA,
      status: cliente.iD_STATUS,
      consulado: cliente.consulado,
      relatO_INICIAL: cliente.relatO_INICIAL,
    });
  }

  visualizarDetalhes(cliente: Cliente): void {
    // TODO: Implementar visualização detalhada do cliente
    console.log("Visualizar detalhes:", cliente);
  }

  onSubmit(): void {
    debugger;
    if (this.cadastroForm.valid) {
      const formValue = this.cadastroForm.value;
      debugger;
      let dados = {
        ID_USUARIO: this.clienteSelecionado.iD_USUARIO,
        ID_USUARIO_CLIENTE: this.clienteSelecionado.iD_USUARIO_CLIENTE,
        NOME: formValue.nome,
        CPF: formValue.cpf,
        EMAIL: formValue.email,
        TELEFONE: formValue.telefone,
        ENDERECO: formValue.endereco,
        TIPO_DEMANDA: formValue.tipO_DEMANDA,
        ID_STATUS: parseInt(formValue.status),
        CONSULADO: formValue.consulado,
        RELATO_INICIAL: formValue.relatO_INICIAL,
      };

      let url = API + "Usuario/Usuario/cliente";

      debugger;

      this.util.showLoading();
      this.ajaxService.post(url, dados).subscribe({
        next: (response) => {
          this.util.closeLoading();
          this.carregarClientes();
          this.modalRef.close();
          this.cadastroForm.reset();
        },
        error: (error) => {
          this.util.closeLoading();
          console.error("Erro ao atualizar cliente:", error);
        },
      });
    }
  }

  aplicarFiltros(): void {
    this.clientesFiltrados = this.clientes.filter((cliente) => {
      const matchNome =
        !this.filtroNome ||
        cliente.nome.toLowerCase().includes(this.filtroNome.toLowerCase());
      const matchCpf = !this.filtroCpf || cliente.cpf.includes(this.filtroCpf);
      const matchTipoDemanda =
        !this.filtrotipO_DEMANDA ||
        cliente.tipO_DEMANDA === this.filtrotipO_DEMANDA;
      const matchStatus =
        !this.filtroStatus || cliente.nomeStatus === this.filtroStatus;
      const matchMensagem =
        !this.filtroMensagem ||
        (this.filtroMensagem === "true" && cliente.temMensagem) ||
        (this.filtroMensagem === "false" && !cliente.temMensagem);

      return (
        matchNome &&
        matchCpf &&
        matchTipoDemanda &&
        matchStatus &&
        matchMensagem
      );
    });
    this.pageIndex = 0; // Reset para primeira página ao filtrar
  }

  limparFiltros(): void {
    this.filtroNome = "";
    this.filtroCpf = "";
    this.filtrotipO_DEMANDA = "";
    this.filtroStatus = "";
    this.filtroMensagem = "";
    this.clientesFiltrados = [...this.clientes];
    this.pageIndex = 0; // Reset para primeira página ao limpar filtros
  }

  limparFormulario(): void {
    this.cadastroForm.reset();
    this.clienteSelecionado = null;
  }

  // Métodos para gerenciar seleção múltipla de áreas
  isAreaSelected(areaValue: string): boolean {
    const selectedAreas = this.cadastroForm.get('AREA_RELACAO_PPGIT')?.value || [];
    return selectedAreas.includes(areaValue);
  }

  toggleArea(areaValue: string, event: any): void {
    const selectedAreas = this.cadastroForm.get('AREA_RELACAO_PPGIT')?.value || [];
    
    if (event.target.checked) {
      // Adicionar área se não estiver selecionada
      if (!selectedAreas.includes(areaValue)) {
        selectedAreas.push(areaValue);
      }
    } else {
      // Remover área se estiver selecionada
      const index = selectedAreas.indexOf(areaValue);
      if (index > -1) {
        selectedAreas.splice(index, 1);
      }
    }
    
    this.cadastroForm.get('AREA_RELACAO_PPGIT')?.setValue(selectedAreas);
  }

  gettipO_DEMANDALabel(tipo: string): string {
    const labels: { [key: string]: string } = {
      jure_sanguinis: "Jure Sanguinis",
      filho_menor: "Filho Menor",
      outra_demanda: "Outra Demanda",
    };
    return labels[tipo] || tipo;
  }

  // Métodos de paginação
  onPageChange(newPageIndex: number): void {
    this.pageIndex = newPageIndex;
  }

  onPageSizeChange(): void {
    this.pageIndex = 0; // Reset para primeira página ao mudar o tamanho
  }

  getTotalPages(): number {
    return Math.ceil(this.clientesFiltrados.length / this.pageSize);
  }

  min(a: number, b: number): number {
    return Math.min(a, b);
  }

  carregarArquivos(cliente): void {
    this.loadingArquivos = true;
    this.clienteSelecionado = cliente;

    debugger;
    let url = API + "Arquivos/Arquivos?ID_USUARIO=" + cliente.iD_USUARIO;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        this.arquivosCliente = response.data;
        this.loadingArquivos = false;
      },
      error: (error) => {
        console.error("Erro ao carregar arquivos:", error);
        this.loadingArquivos = false;
      },
    });
  }

  visualizarArquivo(arquivo: Arquivo): void {
    window.open(BASE_API + arquivo.path.replace("/clientes", ""), "_blank");
  }

  excluirArquivo(arquivo: Arquivo): void {
    if (confirm("Tem certeza que deseja excluir este arquivo?")) {
      let url = API + "Arquivo/Arquivo/" + arquivo.id;
      this.ajaxService.delete(url).subscribe({
        next: (response) => {
          this.arquivosCliente = this.arquivosCliente.filter(
            (a) => a.id !== arquivo.id
          );
        },
        error: (error) => {
          console.error("Erro ao excluir arquivo:", error);
        },
      });
    }
  }

  carregarArvore(cliente): void {
    debugger;
    this.clienteSelecionado = cliente;
    this.arvoreCliente = JSON.parse(this.clienteSelecionado.arvore);
    this.loadingArvore = false;
  }

  getParentescoLabel(parentesco?: string): string {
    switch (parentesco) {
      case "italiano":
        return "Italiano/a";
      case "filho":
        return "Filho/a do/a Italiano/a";
      case "neto":
        return "Neto/a do/a Italiano/a";
      case "bisneto":
        return "Bisneto/a do/a Italiano/a";
      case "trineto":
        return "Trineto/a do/a Italiano/a";
      case "tetraneto":
        return "Tetraneto/a do/a Italiano/a";
      case "pentaneto":
        return "Pentaneto/a do/a Italiano/a";
      case "hexaneto":
        return "Hexaneto/a do/a Italiano/a";
      default:
        return "Cliente";
    }
  }
}
